/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import {
  Switch,
  Button,
  Input,
  Select,
  Form,
  Spin,
  Row,
  Col,
  DatePicker,
  Card,
  Statistic,
  Space,
  Table,
} from "antd";
import {
  CheckOutlined,
  SaveOutlined,
  CopyOutlined,
  ArrowDownOutlined,
  ArrowUpOutlined,
} from "@ant-design/icons";

import "../../../components/AdminComponents/contactStyles.css";
import Sidebar from "../../../components/AdminComponents/SideNav";
import { ClientMenu } from "../../../components/AdminComponents/MenuItems";
import { useParams, NavLink } from "react-router-dom";
import Axios from "../../../api/Axios";
import { message } from "antd";
import { useSelector } from "react-redux";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { SecondaryNavClient } from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import { GetCookie } from "../../../config";
import { capitalizeWords } from "../../../components/icons/ApplicationColor";
const { Option } = Select;
const { Column, ColumnGroup } = Table;

const ClientApiAdd = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();
  const [data1, setData1] = useState([]);
  const [showHris, setShowHris] = useState(false);
  const clientInfo = useSelector((state) => state.orgdeatil);
  const [loading, setLoading] = useState(false);
  const [save, setSave] = useState(true);
  const [copy, setCopy] = useState(0);
  const [allFieldsClear, setAllFieldsClear] = useState(false);
  const [key, setKey] = useState("");
  const [secret, setsecret] = useState("");

  const csrfToken = getCookie("csrftoken");
  const [defaultStartDate, setDefaultStartDate] = useState(dayjs());
  const { RangePicker } = DatePicker;
  const formRef = useRef();

  // Remove TABLE DATA FOR APIS
  const data = [
    {
      key: "1",
      sourceApp: "Streamery",
      lastTransaction: "04 APR 2024",
      failCount: 0,
      successCount: 10,
      type: "Inbound",
    },
  ];

  // Remove END

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  // handle Changes

  const handleReset = () => {
    // formRef.current.resetFields();
  };

  const hrisChange = (change) => {
    setShowHris(change);
  };

  const handleCopy = (current) => {
    //console.log(key, secret, "these are the key and secret");
    if (current === 1) {
      navigator.clipboard.writeText(key);
      setCopy(1);
    } else if (current === 2) {
      navigator.clipboard.writeText(secret);
      setCopy(2);
    }
  };

  //onFinish

  const onFinish = async (values) => {
    //console.log("ON FINISH CALLED");
    //console.log(save, "this is the status of save, based on this do the calls");
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    delete normalizedValues.dateRange;
    //console.log(normalizedValues.status, "STATUS of normalized value");
    //console.log(normalizedValues.hris, "status of hris");
    const selectedDates = values.dateRange;
    if (selectedDates && selectedDates.length > 0) {
      const contract_start_date = selectedDates[0].format("YYYY-MM-DD");
      normalizedValues.live_date = contract_start_date;
      if (selectedDates.length === 2 && selectedDates[1] !== null) {
        const contract_end_date = selectedDates[1].format("YYYY-MM-DD");
        setAllFieldsClear(true);
        normalizedValues.termination_date = contract_end_date;
      }
    }
    //console.log(normalizedValues);
    if (save === true) {
      // do post here
      //console.log("Call post api cause save is true");
      SendApi(normalizedValues);
    } else if (save === false) {
      // do put here
      //console.log("Call put api since post is false");
      UpdateApi(normalizedValues);
    }
  };

  // Api's

  const LoadApi = async () => {
    // GET Api here
    try {
      setLoading(true);
      const res = await Axios.get(`/tnclientlist/${id}/`);
      //console.log(res.status, "this is the status of the response");
      if (res.status === 204) {
        setShowHris(false);
        ApiStatusNone();
      } else if (res.status === 200) {
        //console.log(res.data, "Loading was successful here's the data");
        setSave(false);
        setData1(res.data);
        setKey(res.data["inbound_key"]);
        setsecret(res.data["inbound_secret"]);
      }
      //console.log(res.data, "THis is the response data");
      setLoading(false);
    } catch (err) {
      setLoading(false);
      UpdateFailed();
      //console.log(err, "Error in Loading API");
    }
  };

  const SendApi = async (values) => {
    // Post Api here
    //console.log(values);
    const apiValues = {
      client_id: values.client_id,
      client_name: values.client_name,
      client_status: values.status === true ? 1 : 0,
      source_hris: values.hris === true ? 1 : 0,
      start_date: values.live_date,
      end_date: values.termination_date,
    };
    //console.log(apiValues);
    try {
      setLoading(true);
      const res = await Axios.post(`/tnclientcreate/`, apiValues, {
        headers: { "X-CSRFToken": csrfToken },
      });
      setData1(res.data);
      //console.log(res);
      SaveSuccessful();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      SaveFailed();
      //console.log(err, "ERROR in axios post");
    }
  };

  const UpdateApi = async (values) => {
    // Put Api here
    //console.log("IN PUT API RN");
    const apiValues = {
      client_id: data1.id,
      client_name: values.client_name,
      live_date: values.live_date,
      termination_date: values.termination_date,
      api_client: values.hris === true ? 1 : 0,
      organization: Number(id),
      client_status: values.status === true ? 1 : 0,
    };
    try {
      setLoading(true);
      const res = await Axios.put(`/tnclient/${data1.id}/`, apiValues, {
        headers: { "X-CSRFToken": csrfToken },
      });
      LoadApi();
      //console.log(res.data, "this is response data in put");
      // setData1(res.data)
      setLoading(false);
      UpdateSuccessful();
    } catch (err) {
      setLoading(false);
      //console.log(err);
      UpdateFailed();
    }
  };

  // validators

  const validateDate = (event) => {
    //console.log(event, "THESE ARE THE DATES IN validateDate");
    if (event.target.value !== null && event.target.value !== undefined) {
      setAllFieldsClear(true);
    }
  };

  // MessageFunctions
  const SaveSuccessful = () => {
    setSave(false);
    messageApi.open({
      type: "success",
      content: "Saved",
      duration: 5,
    });
  };
  const ApiStatusNone = () => {
    messageApi.open({
      type: "warning",
      content: "There are no API's",
      duration: 5,
    });
  };
  const UpdateSuccessful = () => {
    messageApi.open({
      type: "success",
      content: "Api details updated",
      duration: 5,
    });
  };
  const SaveFailed = () => {
    setSave(true);
    messageApi.open({
      type: "error",
      content: "Save was unsuccesful",
      duration: 5,
    });
  };
  const UpdateFailed = () => {
    messageApi.open({
      type: "error",
      content: "Update was unsuccesful",
      duration: 5,
    });
  };

  // useEffects
  useEffect(() => {
    //console.log("IN useEffect to update the form values ");
    if (!loading && formRef.current) {
      const formValues = {
        client_name: data1.client_name ? data1.client_name : clientInfo.name,
        client_id: data1.client_id ? data1.client_id : clientInfo.id,
        key: data1.inbound_key,
        secret: data1.inbound_secret,
        start_date: data1.live_date,
        end_date: data1.termination_date,
        status: data1.client_status === 1 ? true : false,
        hris: data1.api_client === 1 ? true : false,
      };

      if (data1.live_date) {
        formValues.dateRange = [dayjs(data1.live_date, "YYYY-MM-DD")];
      }
      if (data1.termination_date) {
        formValues.dateRange = [
          ...(formValues.dateRange || []),
          dayjs(data1.termination_date, "YYYY-MM-DD"),
        ];
      }
      if (data1.api_client === 1) {
        setShowHris(true);
      } else {
        setShowHris(false);
      }
      formRef.current.setFieldsValue(formValues);
    }
  }, [loading, data1]);

  useEffect(() => {
    LoadApi();
  }, []);

  return (
    <div>
      <Sidebar props={ClientMenu}>
        {contextHolder}
        <SecondaryNav menuItems={SecondaryNavClient} id={parseInt(id)} />
        <Spin spinning={loading}>
          {/* <nav> */}
          {/* <div className="light-bar-container">
        <NavLink
          to={`/admin-manager/clients/relationships/${id}/add-contact/${id}`}
          className={(navigationData) =>
            navigationData.isActive
              ? "link-heading-latest-active"
              : "link-heading-latest"
          }
          style={{ paddingLeft: "3rem" }}
        >
          <span>
            <AuditOutlined />
          </span>
          API
        </NavLink>
      </div> */}

          {/* </nav> */}
          <div className="form-container-2">
            <Form
              name="complex-form"
              onFinish={onFinish}
              layout="vertical"
              ref={formRef}
              initialValues={{
                dateRange: [defaultStartDate, null],
              }}
              labelCol={{
                span: 25,
              }}
              wrapperCol={{
                span: 80,
              }}
              style={{
                width: "100%",
                marginBottom: "150px",
              }}
            >
              <div className="group1">
                <div className="form-heading">
                  {" "}
                  {capitalizeWords("API Settings")}
                </div>
                <div className="antd-test-client" style={{ marginTop: "2rem" }}>
                  <Row gutter={20} style={{ marginLeft: "2rem" }}>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Client ID</p>}
                      >
                        <Form.Item name="client_id" noStyle>
                          <Input className="my-form-input-antd-test" disabled />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Client Name</p>}
                      >
                        <Form.Item name="client_name" noStyle>
                          <Input className="my-form-input-antd-test" disabled />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={<p className="my-form-lables">Status</p>}
                      >
                        <Input.Group compact>
                          <Form.Item name="status" noStyle>
                            <Select
                              placeholder="Select Status"
                              className="my-form-input-antd-test"
                            >
                              <Option value={true}>Active</Option>
                              <Option value={false}>Inactive</Option>
                            </Select>
                          </Form.Item>
                        </Input.Group>
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                      <Form.Item
                        label={
                          <p className="my-form-lables">Source From HRIS</p>
                        }
                      >
                        <Form.Item name="hris" noStyle initialValue={false}>
                          <Switch
                            checked={showHris}
                            checkedChildren=" YES "
                            unCheckedChildren=" NO "
                            onChange={(e) => {
                              hrisChange(e);
                            }}
                          />
                        </Form.Item>
                      </Form.Item>
                    </Col>
                  </Row>

                  {showHris && (
                    <div className="transition-container">
                      {/* table section for hris table */}
                      <Row gutter={20} style={{ marginLeft: "2rem" }}>
                        <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                          <Form.Item
                            label={<p className="my-form-lables">Key</p>}
                          >
                            <Form.Item name="key" noStyle>
                              <Input
                                disabled
                                //   defaultValue={key}
                                className="my-form-input-antd-test"
                                addonAfter={
                                  copy === 1 ? (
                                    <CheckOutlined />
                                  ) : (
                                    <CopyOutlined
                                      onClick={() => handleCopy(1)}
                                    />
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </Form.Item>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                          <Form.Item
                            label={<p className="my-form-lables">Secret</p>}
                          >
                            <Form.Item name="secret" noStyle>
                              <Input
                                disabled
                                //   defaultValue={secret}
                                className="my-form-input-antd-test"
                                addonAfter={
                                  copy === 2 ? (
                                    <CheckOutlined />
                                  ) : (
                                    <CopyOutlined
                                      onClick={() => handleCopy(2)}
                                    />
                                  )
                                }
                                style={{ cursor: "pointer" }}
                              />
                            </Form.Item>
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={12} md={10} lg={5} xl={5}>
                          <Form.Item
                            name="dateRange"
                            label={<p className="my-form-lables">Date</p>}
                          >
                            <RangePicker
                              name="dateRange"
                              // value={startDate, endDate}
                              style={{
                                padding: "5px",
                                paddingRight: "10px",
                              }}
                              onBlur={(event) => {
                                validateDate(event);
                              }}
                              className="my-form-input-end"
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      {/* Table for API's */}
                      {/* <div className="form-heading">API Transactions Log</div>
    <div style={{width: '69%', marginLeft:'2rem'}}>
        <Table dataSource={data}  pagination={false} 
        size="small"
        
        bordered
        className="contacts-table"
        >
            <Column title="Source App" dataIndex="sourceApp" key="firstName" width={30}/>
            <Column title="Last Transaction Date" dataIndex="lastTransaction" key="age" width={60} />
            <Column title="Type" key="action" dataIndex="type" width={20} />
            <Column title="Success Count" dataIndex="successCount" key="address" width={20} />
            <Column title="Failed Count" key="action" dataIndex="failCount" width={20} />

        </Table>
    </div>
                 */}

                      {/* TABLE FOR API LOG END */}
                    </div>
                  )}
                </div>
              </div>
              <div
                style={{ display: "inline-block", marginLeft: "5rem" }}
              ></div>
              {/* <div style={{ display: "inline-block", marginLeft: "16px" }}>
            <Form.Item label=" " colon={false}>
              <Button type="primary" htmlType="button" onClick={handleReset}>
                Reset
              </Button>
            </Form.Item>
          </div> */}
              <div style={{ display: "inline-block" }}>
                <Form.Item label=" " colon={false}>
                  {save && !allFieldsClear ? (
                    <Button
                      disabled
                      type="primary"
                      htmlType="submit"
                      // className="my-form-input-end"
                      rules={{
                        type: "object",
                        required: true,
                        message: "Please input publishDate",
                        whitespace: false,
                      }}
                      style={{
                        background: "#f58029",
                        fontWeight: "600",
                      }}
                      className="save-update-btn"
                      // onClick={SaveSuccessful}
                    >
                      Save
                      <SaveOutlined />
                    </Button>
                  ) : save ? (
                    <Button
                      type="primary"
                      htmlType="submit"
                      // className="my-form-input-end"
                      rules={{
                        type: "object",
                        required: true,
                        message: "Please input publishDate",
                        whitespace: false,
                      }}
                      style={{
                        background: "#f58029",
                        fontWeight: "600",
                      }}
                      className="save-update-btn"
                      // onClick={SaveSuccessful}
                    >
                      Save
                      <SaveOutlined />
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      htmlType="submit"
                      // className="my-form-input-end"

                      style={{
                        background: "#f58029",
                        fontWeight: "600",
                      }}
                      className="save-update-btn"
                      //   onClick={SaveSuccessful}
                    >
                      Update
                      <SaveOutlined />
                    </Button>
                  )}
                </Form.Item>
              </div>
            </Form>
          </div>
        </Spin>
      </Sidebar>
    </div>
  );
};

export default ClientApiAdd;
